var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgFileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.875H10.5V1.625L15.75 6.875ZM10.5 8.1875H15.75V20.6562C15.75 21.7637 14.8477 22.625 13.7812 22.625H1.96875C0.861328 22.625 0 21.7637 0 20.6562V3.59375C0 2.52734 0.861328 1.625 1.96875 1.625H9.1875V6.875C9.1875 7.61328 9.76172 8.1875 10.5 8.1875ZM10.0488 12.4941L6.80859 16.2676L5.57812 15.0781C5.20898 14.668 4.59375 14.668 4.22461 15.0781C3.81445 15.4473 3.81445 16.0625 4.22461 16.4316L6.19336 18.4004C6.35742 18.6055 6.60352 18.7285 6.89062 18.7285C6.89062 18.7285 6.89062 18.7285 6.89062 18.6875C7.17773 18.6875 7.42383 18.5645 7.62891 18.3594L11.5664 13.7656C11.8945 13.3555 11.8535 12.7402 11.4434 12.3711C11.0332 12.043 10.418 12.084 10.0488 12.4941Z",
    fill: "#13C1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9707 4.48047L13.8945 1.4043C13.4023 0.912109 12.7461 0.625 12.0488 0.625H4.625C3.14844 0.625 2 1.81445 2 3.25V19C2 20.4766 3.14844 21.625 4.625 21.625H15.125C16.5605 21.625 17.75 20.4766 17.75 19V6.32617C17.75 5.62891 17.4629 4.97266 16.9707 4.48047ZM15.7812 19C15.7812 19.3691 15.4531 19.6562 15.125 19.6562H4.625C4.25586 19.6562 3.96875 19.3691 3.96875 19V3.29102C3.96875 2.92188 4.25586 2.63477 4.625 2.63477H11.1875V5.875C11.1875 6.61328 11.7617 7.1875 12.5 7.1875H15.7402V19H15.7812ZM8.80859 13.9551L7.57812 12.7246C7.16797 12.3555 6.55273 12.3555 6.18359 12.7246C5.77344 13.1348 5.77344 13.75 6.18359 14.1191L8.15234 16.0879C8.35742 16.293 8.60352 16.375 8.89062 16.375C9.17773 16.375 9.42383 16.252 9.62891 16.0469L13.5664 11.4531C13.8945 11.043 13.8535 10.4277 13.4434 10.0586C13.0332 9.73047 12.418 9.77148 12.0488 10.1816L8.80859 13.9551Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFileCheck);
export default __webpack_public_path__ + "static/media/img_fileCheck.eb0951d53ec65d9791beeadc15875d07.svg";
export { ForwardRef as ReactComponent };